

function assign(obj, keyPath, value) {
  const lastKeyIndex = keyPath.length - 1
  for (var i = 0; i < lastKeyIndex; ++i) {
    const key = keyPath[i]
    if (!(key in obj)) {
      obj[key] = {}
    }
    obj = obj[key]
  }
  obj[keyPath[lastKeyIndex]] = value
}

export function formSyntaxToJson (str, val) {
  const res = {}
  assign(res, str.split('[').map(e => e.replace(']', '')), val)
  return res
}
